import { createUseStyles } from 'react-jss'
import { LIGHTER_GRAY } from '@omnilert/components'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  parentTitle: {
    color: LIGHTER_GRAY,
    fontWeight: '500',
    lineHeight: '20px'
  },
  title: {
    fontFamily: 'BentonSansBold',
    fontSize: '22px',
    fontWeight: '500'
  },
  wrapper: {
    display: 'flex',
    justifyContent: 'space-between'
  }
})

export default useStyles
